<template>
  <div class="product-details-content-setup-step-04">
    <div class="mb-5">
      <step-title
        title="Suporte"
        description="Configure suporte para o seus alunos."
        icon="icon-suport"
      />
    </div>

    <form-group
      v-model="control.form.description"
      id="description"
      label="Descrição (Opcional)"
      placeholder="Ex. Caso precise da ajuda do nosso suporte para tratar sobre o conteúdo do seu curso, entre em contato conosco."
      textarea
      :errors="control.errors.description"
      rows="5"
    />
    <div class="mb-5">
      <small>
        Essa descrição aparece no topo explicando como funciona o suporte.
      </small>
    </div>

    <form-group
      v-model="control.form.phone"
      :errors="control.errors.phone"
      type="tel"
      id="phone"
      placeholder="Digite um número de telefone para que seus alunos entre em contato com você"
      mask="(##) #####-####"
      label="Telefone (opcional)"
      class="mb-5"
    />

    <form-group
      v-model="control.form.email"
      :errors="control.errors.email"
      type="email"
      id="email"
      placeholder="Digite um e-mail para que seus alunos entre em contato com você"
      label="E-mail (opcional)"
      class="mb-5"
    />

    <form-group
      v-model="control.form.link_chat_whatsapp"
      :errors="control.errors.link_chat_whatsapp"
      id="link_chat_whatsapp"
      placeholder="Insira  a URL do chat"
      label="Link para Chat do Whatsapp (Opcional)"
    />
    <div class="mb-5">
      <small class="sm">
        O aluno será redirecionado para este link
      </small>
    </div>

    <form-group
      v-model="control.form.opening_hours"
      id="opening_hours"
      label="Horário de atendimento (opcional)"
      placeholder="Ex. seg a sex, das 8h as 18h"
      textarea
      :errors="control.errors.opening_hours"
      rows="5"
    />
    <small>
      Descreva quando estará disponível o suporte.
    </small>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers";
import get from "lodash/get";
export default {
  props: ["form"],
  data() {
    return {
      control: formFields(
        [
          "description",
          "phone",
          "email",
          "link_chat_whatsapp",
          "opening_hours"
        ],
        {
          ...get(this.form, "metadata_support", {})
        }
      )
    };
  },
  watch: {
    "form.metadata_support"(v) {
      this.control.form = { ...v };
    },
    control: {
      deep: true,
      handler(val) {
        for (let k in val.form) {
          this.form.metadata_support[k] = val.form[k];
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.product-details-content-setup-step-04 {
  small {
    color: var(--l-neutral-45, rgba(87, 88, 107, 0.88));
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;

    &.sm {
      font-size: 10px;
    }
  }
}
</style>
